// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__ZFyMZ","imageUploader":"EGiftCard_imageUploader__3xFVw"};